<div class="btn-toolbar">
    <div class="btn-group">
        <ng-template ngFor let-visualizacaoModo [ngForOf]="visualizacaoModos">
            <label class="btn btn-light m-0" [class.active]="visualizacaoModo.id === visualizacao.modo" for="visualizacaoAtividadeModo_{{visualizacaoModo.id}}" [title]="visualizacaoModo.nome">
                <input type="radio" class="custom-control-input" name="visualizacaoAtividadeModo" id="visualizacaoAtividadeModo_{{visualizacaoModo.id}}"
                    [value]="visualizacaoModo.id" [ngModel]="visualizacao.modo" (ngModelChange)="onChangeVisualizacaoModo($event ? $event : null)"> <i [class]="visualizacaoModo.iconClass"></i>                                       
            </label>                 
        </ng-template>
    </div>
</div>